import React, { type FC } from 'react';
import cn from 'classnames';

import { useMetaData } from '../../hooks/use-meta-data';

import styles from './styles.css';
import type { TSharingDetails } from './models';

export const Component: FC<TSharingDetails> = ({
    Button,
    Img,
    NamedContainer,
    Text,
    className,
    config,
    shareDetails,
}) => {
    const { description, title } = useMetaData();

    const details = shareDetails.map(({ dataTestId, iconUrl, label, link }, i) => {
        const isLastElem = i === shareDetails.length - 1;
        const margin = isLastElem ? 0 : config.marginBottom;

        const handleCopy = async () => {
            const currentUrl = window.location.href;
            try {
                await navigator.clipboard.writeText(currentUrl);
            } catch {
                console.error('Не удалось скопировать ссылку');
            }
        };

        const handleClick = isLastElem ? handleCopy : undefined;

        return (
            <Button
                key={i}
                dataTestId={dataTestId}
                href={link
                    ?.replace('{url}', window.location.href)
                    .replace('{title}', title)
                    .replace('{text}', description ?? '')}
                onClick={handleClick}
                styler={{ marginBottom: margin }}
                target="_blank"
                view="ghost"
            >
                <NamedContainer name="leftAddons">
                    <Img height={24} src={iconUrl} width={24} />
                </NamedContainer>
                <Text
                    className={cn(styles.external, styles.text)}
                    styler={{ margin: 0, marginLeft: config.marginLeft }}
                    view={config.view}
                >
                    {label}
                </Text>
            </Button>
        );
    });

    return <div className={cn(className, styles.container)}>{details}</div>;
};
